export const MAIN = {
    wha_phone : process.env.VUE_APP_WHA_PHONE,
    tidio_code: process.env.VUE_APP_TIDIO_CODE,
    google_id: process.env.VUE_APP_GOOGLE_ID,
};